import { useMutation } from 'react-query';

import { associateCardWithLogicChecker as mutationFn } from 'api/endPoints/associateCardWithLogicChecker';

export const useMutationSetAssociateCardWithLogicChecker = () => {
    return useMutation<any, QueryError, ISetAssociateCardWithLogicCheckerPayload>('copyQualitySettings', (params) =>
        mutationFn(params),
    );
};

export interface ISetAssociateCardWithLogicCheckerPayload {
    metaDataId?: number;
    checkId?: number;
    cardId: number;
}
